export const CHECKOUT_URL = 'https://driving-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/2WZoHFXt1oycFGtSezsksm/Diseno_sin_titulo_(69).png'

export const HERO_IMAGE_ALT =
  'Driving Instructor Ready complete system: 6 volumes, 150 ready-to-teach driving lessons, Class Finder tablet and 5 professional bonus guides'

export const PRIMARY_CTA = 'GET DRIVING INSTRUCTOR READY NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Driving Foundations, Vehicle Control & First Lessons' },
  { kind: 'included', label: 'Volume 2 — Observation, Road Positioning & Traffic Awareness' },
  { kind: 'included', label: 'Volume 3 — Junctions, Intersections, Roundabouts & Lane Decisions' },
  { kind: 'included', label: 'Volume 4 — Parking, Reversing & Essential Maneuvers' },
  { kind: 'included', label: 'Volume 5 — Hazard Awareness, Complex Roads & Independent Driving' },
  { kind: 'included', label: 'Volume 6 — 150 Ready-to-Teach Driving Lessons' },
  { kind: 'bonus', label: 'Driving Instructor Cueing & Error Correction Handbook' },
  { kind: 'bonus', label: 'Driving Student Assessment & Progress Tracking System' },
  { kind: 'bonus', label: 'Driving Lesson Planning & Sequencing System' },
  { kind: 'bonus', label: 'Driving Instructor Troubleshooting & Problem-Solving Manual' },
  { kind: 'bonus', label: '100 Driving Practice Challenges, Skill Drills & Student Tasks' },
  { kind: 'included', label: '100% Visual Teaching Material' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
